import { useEffect, useState } from 'react';
import axiosUI from '../../../axiosUI';
import { RESOURCE_STATES, OPERATION_TYPES } from '../../../constants';

export function useChannelToggle() {
  const [state, setState] = useState('idle'); // `idle`, `pending`, `resolved`, `rejected`
  const [draftsAvailable, setDraftsAvailable] = useState(false);
  const [toggles, setToggles] = useState([]);
  
  const fetchChannelToggles = async () => {
    try {
      setState('pending');
      const { data } = await axiosUI.get('/api/channels/toggle');

      if (data.some(({ state }) => state === RESOURCE_STATES.DRAFT)) {
        setDraftsAvailable(true);
      }

      const filteredData = data.filter(({ state }) => state === RESOURCE_STATES.PUBLISHED);
      
      setToggles(filteredData);
      setState('resolved');
    } catch (error) {
      setState('error');
    }
  }

  const updateToggleStatus = async ({
    channel_type,
    status
  }) => {
    const payload = [{
      channel_type,
      status: !status,
      operation_type: OPERATION_TYPES.UPDATE // Switched to CREATE because of a bug in the backend, should be UPDATE
    }];

    try {
      setState('pending');
      await axiosUI.post('/api/channels/toggle', payload);
      setState('resolved');
    } catch (error) {
      setState('error');
    } finally {
      // Reset the current toggle list after the status update
      setToggles([]);
      // Fetch the toggles with the correct statuses after updating
      await fetchChannelToggles();
    }
  }

  useEffect(() => {
    if (state === 'idle') {
      fetchChannelToggles();
    }
  }, [state]);

  return [state, toggles, updateToggleStatus, draftsAvailable];
}
